/*
 * Cohort 001 popup.
 * Claude QA 10-7, timing updated 10-21 (v12), 10-26:
 *  - minimum 8s delay on most pages
 *  - on product pages: wait for 20s or 50% scroll, whichever comes first (so it doesn't cover Add to Bag)
 *  - wait until the cookie banner has been answered
 *  - 10-26: never pop over an open drawer (search, menu, cart). If one is open when the timer fires,
 *    wait until it closes, then show 2s later. CSS in am-qa-1009.liquid also hides it while a drawer is open.
 *  - 10-26 (b): the close button is wired before the "already dismissed" early return, so the X still works
 *    when the popup is reopened from the Join Cohort 001 tab on a later visit.
 *  - a dismissal is remembered for 14 days, not just this visit
 */
class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Math.max(Number(this.dataset.delay) || 0, 8);
    this.isProductPage = document.body.classList.contains("template-product");

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.popup.classList.add("hidden");
        this.popup.classList.remove("wt-popup-fade-in");
        this.markDismissed();
      });
    }
    // Safety net: a click on the overlay outside the card also closes it.
    this.popup.addEventListener("click", (event) => {
      if (event.target === this.popup) {
        this.popup.classList.add("hidden");
        this.popup.classList.remove("wt-popup-fade-in");
        this.markDismissed();
      }
    });

    if (this.hasSubscription || this.isDismissed()) return;

    this.waitForConsent(() => this.schedule());
  }

  drawerOpen() {
    const b = document.body.classList;
    return b.contains("search-overlay-on") || b.contains("page-overlay-on") || b.contains("menu-open") || b.contains("menu-drawer-overlay-on");
  }

  whenDrawersClosed(callback) {
    if (!this.drawerOpen()) { callback(); return; }
    const obs = new MutationObserver(() => {
      if (this.drawerOpen()) return;
      obs.disconnect();
      setTimeout(() => this.whenDrawersClosed(callback), 2000);
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  schedule() {
    let shown = false;
    const show = () => {
      if (shown || this.isDismissed()) return;
      shown = true;
      window.removeEventListener("scroll", onScroll);
      this.whenDrawersClosed(() => {
        if (this.isDismissed()) return;
        this.popup.classList.remove("hidden");
        this.popup.classList.add("wt-popup-fade-in");
      });
    };

    if (this.isProductPage) {
      var onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.5) show();
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      setTimeout(show, 20000);
    } else {
      var onScroll = () => {};
      setTimeout(show, this.delay * 1000);
    }
  }

  waitForConsent(callback) {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.shouldShowBanner === "function" && privacy.shouldShowBanner()) {
        document.addEventListener("visitorConsentCollected", () => callback(), { once: true });
        return;
      }
    } catch (e) {}
    callback();
  }

  isDismissed() {
    try {
      if (sessionStorage.getItem("hideNotificationPopup") === "true") return true;
    } catch (e) {}
    try {
      const until = Number(localStorage.getItem("hideNotificationPopupUntil") || 0);
      return until > Date.now();
    } catch (e) {
      return false;
    }
  }

  markDismissed() {
    try {
      sessionStorage.setItem("hideNotificationPopup", "true");
    } catch (e) {}
    try {
      localStorage.setItem("hideNotificationPopupUntil", String(Date.now() + 14 * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }
}

customElements.define("notification-popup", NotificationPopup);
